'use strict';

// stylesheet import
import '../sass/main.sass';

import React from 'react';
import ReactDOM from 'react-dom';
import { IntersectionObserverToggleClass } from './modules/class-intersection-observer-toggleclass';
import { IsLegacyIE } from './modules/checking-legacy-ie';
import { FindOS } from './modules/checking-os';
import { FindBrowser } from './modules/checking-browser';
import { Generator } from './tsx/app/Generator';

// React
const App: React.VFC = (): JSX.Element => {
  return (
    <>
      <Generator />
    </>
  )
};
ReactDOM.render( <App />, document.getElementById('generator') );

// Intersection Observer
new IntersectionObserverToggleClass({
  selector: '.observe_target', 
  className: 'observed', 
  toggle: true
});

// checking legacy IE
IsLegacyIE();

// checking OS
FindOS();

// checking browser
FindBrowser();